module.exports = __webpack_public_path__ + "img/Group 768mail.12bfe5dd.svg";